module.exports = __webpack_public_path__ + "img/img3.a26bbdf3.png";